import React, { useState, useContext, useEffect } from 'react'
import { Table } from 'antd'
import { formatDateFromTimestamp, withEmptyRender } from '@utils/common'
import fetch from '@utils/request'
import api from '@api'
import usePagination from '@hooks/usePagination'
import PatientContext from '../context'

const Surgery = ({ targetPage, render }) => {
  const { activeVisit, projectId, patientId } = useContext(PatientContext)
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [page, setPage, setTotal, pagination] = usePagination({
    initialPage: {
      pageIndex: targetPage || 1,
      pageSize: 10,
    },
  })
  const columns = withEmptyRender([
    {
      title: '申请单号',
      dataIndex: 'surgery_request_no',
      render,
    },
    {
      title: '标准手术操作名称',
      dataIndex: 'standard_icd9_name',
      render,
    },
    {
      title: '标准手术操作编码',
      dataIndex: 'standard_icd9_code',
      render,
    },
    {
      title: '源手术操作名称',
      dataIndex: 'origin_icd9_name',
      render,
    },
    {
      title: '源手术操作编码',
      dataIndex: 'origin_icd9_code',
      render,
    },
    {
      title: '手术开始时间',
      dataIndex: 'surgery_begin_time',
      render: (value, record) => render(formatDateFromTimestamp(value) || '-', record),
    },
    {
      title: '手术结束时间',
      dataIndex: 'surgery_end_time',
      render: (value, record) => render(formatDateFromTimestamp(value) || '-', record),
    },
    {
      title: '切口类型',
      dataIndex: 'wound_level_name',
      render,
    },
    {
      title: '麻醉方式',
      dataIndex: 'anes_method_name',
      render,
    },
    {
      title: '术前诊断',
      dataIndex: 'pre_surgery_diag_name',
      render,
    },
    {
      title: '术前诊断编码',
      dataIndex: 'pre_surgery_diag_code',
      render,
    },
    {
      title: '术后诊断',
      dataIndex: 'post_surgery_diag_name',
      render,
    },
    {
      title: '术后诊断编码',
      dataIndex: 'post_surgery_diag_code',
      render,
    },
  ])

  const handleTableChange = (pagination) => {
    setPage({
      pageIndex: pagination.current,
      pageSize: pagination.pageSize,
    })
  }
  const fetchRecord = async () => {
    const pager = {
      pageNumber: page.pageIndex,
      pageSize: page.pageSize,
    }
    setLoading(true)
    const { indexNo, type } = activeVisit
    const { content, totalCount } = await fetch({
      url: api.patientApi.patientRecords,
      method: 'GET',
      params: {
        patientId,
        indexNo,
        type: 6,
        category: type,
        proId: projectId,
        ...pager,
      },
    })
    setData(content)
    setLoading(false)
    setTotal(totalCount)
  }

  useEffect(() => {
    if (patientId) {
      fetchRecord()
    }
  }, [activeVisit, page])

  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        rowKey={(record) => record.id}
        size="small"
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
        scroll={{ x: 'max-content' }}
      />
    </>
  )
}

export default Surgery
